module.exports = __webpack_public_path__ + "static/media/[Professor_Teas]2014-04-16.23ba03ee.md";